import Script from 'next/script';

const luckyOrangeId = process.env.NEXT_PUBLIC_LUCKY_ORANGE_ID;

const LuckyOrangeScript: React.FC = () => {
    if (!luckyOrangeId) {
      return null;
    }
  
    return (
      <Script
        id="lucky-orange"
        src={`https://tools.luckyorange.com/core/lo.js?site-id=${luckyOrangeId}`}
        async
        defer
      />
    );
  };
  
  export default LuckyOrangeScript;
